import logo from './logo.svg';
import './App.css';

import AlleviClientTester from './AlleviClientTester'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        Allevi Client Tester
      </header>
      <main>
        <AlleviClientTester/>
      </main>
    </div>
  );
}

export default App;
